import { useMemo } from 'react'
import * as THREE from 'three'

import { useTodoListContext } from '@routes/TodoList/Context'
import { useGlobalizedFacings } from '@state/layout/queries'
import { type TaskItemResponse } from '@state/todoList'
import { type FacingGeometry } from '@utils/geometry'

interface TaskWithFacing {
  facingId: string
  action: TaskItemResponse['action']
  geometry: FacingGeometry
  quaternion: THREE.Quaternion
  isNew: boolean
  isCompleted: boolean
}

export function useTaskFacings(): TaskWithFacing[] {
  const { filteredTodoList } = useTodoListContext()
  const { data: facingGeometries } = useGlobalizedFacings()

  return useMemo(() => {
    if (!facingGeometries) return []

    const aggregated = new Map<string, TaskWithFacing>() // backend may send multiple todos per facing
    for (const item of filteredTodoList) {
      const { isNew, action } = item
      const isCompleted = item.isCompleted()

      for (const placement of item.product.placements) {
        const facingId = placement.facingId
        if (!facingId) continue

        const facingGeometry = facingGeometries.get(facingId)
        if (!facingGeometry) continue

        const { geometry, quaternion } = facingGeometry

        aggregated.set(facingId, { facingId, action, geometry, quaternion, isNew, isCompleted })
      }
    }

    return Array.from(aggregated.values())
  }, [filteredTodoList, facingGeometries])
}